import React, { useRef, useState } from 'react'
import { unstable_batchedUpdates } from 'react-dom'
import styled from 'styled-components'
import { useEffect } from 'react'

export const S_PopoverContainer = styled.div`
  position: fixed;
  min-width: 100px;
  white-space: normal; /* Prevent parents like table cell from affecting this */
  max-width: 200px;
  background-color: #fff;
  box-shadow: 0 0 6px #ccc;
  z-index: 3000;
  padding: 10px;
  font-size: 13px;
`

const PopoverContainer = React.forwardRef((props, ref) => {
  let style = {}
  if (window.innerWidth - props.left <= 200) {
    style.right = props.right
  } else {
    style.left = props.left
  }

  if (window.innerHeight - props.top <= 200) {
    style.bottom = props.bottom
  } else {
    style.top = props.top
  }

  return (
    <S_PopoverContainer ref={ref} style={style}>
      {props.children}
    </S_PopoverContainer>
  )
})

export const Popover = ({ indicator = () => {}, onClose = () => {}, overrideShow = true, children = undefined }) => {
  const ref = useRef()
  const [show, setShow] = useState(false)
  const [indicatorBox, setIndicatorBox] = useState({ top: 0, left: 0, right: 0, x: 0, width: 0, y: 0 })
  const Indicator = indicator

  const showBox = (e) => {
    let bounding = e.currentTarget.getBoundingClientRect()
    unstable_batchedUpdates(() => {
      //eliminating jitter
      if (
        bounding.x - indicatorBox.x > 3 ||
        bounding.x - indicatorBox.x < -3 ||
        bounding.y - indicatorBox.y > 3 ||
        bounding.y - indicatorBox.y < -3
      ) {
        setIndicatorBox(bounding)
      }
      setShow(true)
    })
  }

  const handleClick = (e) => {
    if (ref.current && ref.current.contains(e.target)) {
      // If clicking inside the popver, do nothing
      return
    }

    // If clicking outside, hide
    setShow(false)
    onClose()
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClick)

    return () => {
      document.removeEventListener('mousedown', handleClick)
    }
  })

  return (
    <>
      {Indicator({ onClick: showBox })}
      {show && overrideShow && (
        <PopoverContainer
          bottom={window.innerHeight - indicatorBox.y + 3}
          left={indicatorBox.x}
          ref={ref}
          right={window.innerWidth - indicatorBox.x - 1}
          top={indicatorBox.y + indicatorBox.height + 3}
        >
          {children}
        </PopoverContainer>
      )}
    </>
  )
}
